import type { QueryClient } from '@tanstack/react-query';
import {
  applyPcoCollaborationListEffects,
  handleNotificationToast,
  type NotificationHandlerContext,
} from '@/lib/notification-side-effects';
import { useNotificationStore } from '@/stores/notificationStore';
import { parseNotification } from '@/types/notification';
import type { RealtimeEvent } from '@/types/realtime';

export { resyncNotificationModel } from '@/hooks/api/useNotifications';

function readNotificationPayload(payload: Record<string, unknown>): Record<string, unknown> | null {
  const nested = payload.notification;
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    return nested as Record<string, unknown>;
  }
  return payload;
}

/**
 * 实时 notification_created：更新铃铛，并刷新承制邀请被撤回后的待处理列表。
 * 其余缓存刷新、权限变更和访问失效仍由 project_cache/org_cache 负责。历史补拉不重放副作用。
 */
export function handleNotificationRealtimeEvent(
  queryClient: QueryClient,
  event: RealtimeEvent,
  context: NotificationHandlerContext
): void {
  if (event.event !== 'notification_created' && event.event !== 'notification') {
    return;
  }

  try {
    const rawNotification = readNotificationPayload(event.payload);
    if (!rawNotification) return;
    const notification = parseNotification(rawNotification);
    useNotificationStore.getState().pushNotification(notification);
    handleNotificationToast(notification, context);
    applyPcoCollaborationListEffects(queryClient, notification);
  } catch (error) {
    console.warn('[realtime] notification event parse failed', error, event);
  }
}
